// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    0,
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "富媒体编辑技术",
      "tec": "孟轩羽",
      "week": "1-4,7-14周",
      "add": "实训楼F座304信机"
    },
    0,
    0,
    0,
    0
  ],
  "3": [
    0,
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "富媒体编辑技术",
      "tec": "孟轩羽",
      "week": "1-4,7-14周",
      "add": "实训楼F座304信机"
    },
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
